var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { List, Message } from "semantic-ui-react";
/**
 * Display *all* errors
 */
var AllErrorDisplay = /** @class */ (function (_super) {
    __extends(AllErrorDisplay, _super);
    function AllErrorDisplay() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AllErrorDisplay.prototype.render = function () {
        if (this.props.errors.length === 0) {
            return '';
        }
        return React.createElement(Message, { error: true },
            React.createElement(List, { items: this.props.errors.map(function (e, index) {
                    return React.createElement(React.Fragment, { key: index },
                        e.path,
                        ": ",
                        e.msg);
                }) }));
    };
    return AllErrorDisplay;
}(React.PureComponent));
export default AllErrorDisplay;
//# sourceMappingURL=AllErrorDisplay.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/AllErrorDisplay.js
// module id = 1161
// module chunks = 0